export default "__VITE_ASSET__9e0ef475__"